import React from 'react'
import './ImageBlock.scss'

const ImageBlock = ({ block }) => {
  const imageUrl = `${process.env.REACT_APP_API_URL}${block.ImageUrl}`

  return (
    <div className="block block-image">
      {block.ImageUrl && (
        <img src={imageUrl} alt={block.Heading || ''} />
      )}
    </div>
  )
}

export default ImageBlock
